import { useQueryClient } from '@tanstack/react-query';
import type { InitialProps } from '../../lib/types';

export const useAutoSave = () => {
    const queryClient = useQueryClient();

    const autoSave = (data: Partial<InitialProps['storeData']>) => {
        queryClient.setQueryData(['store-data'], (old: any) => ({
            ...old,
            storeData: {
                ...old?.storeData,
                ...data,
            },
            lastModified: new Date().toISOString(),
        }));
    };
    return {
        autoSave,
    };
};
